import React, { useEffect, useRef, useState } from 'react';
import {ReactComponent as LegsBtn} from '../../assets/images/leg-icon.svg';
import {ReactComponent as LegsThumb1} from '../../assets/images/legs-thumb-1.svg';
import {ReactComponent as LegsThumb2} from '../../assets/images/legs-thumb-2.svg';
import {ReactComponent as LegsThumb3} from '../../assets/images/legs-thumb-3.svg';
import {gsap, ScrollTrigger, MotionPathPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

export default function LegsExpansion({expandOnce, handleChange}) {

  let expandRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  let tl = gsap.timeline();
   

  useEffect(() => {
    if(!expanded) {
      tl.to(expandRef.current.childNodes, {
        opacity: 0,
        duration: 0.3,
        stagger: 0.1
      }).yoyo()
      gsap.to(expandRef.current, {
        opacity: 0,
        duration: 1
      });
    } else {
      gsap.to(expandRef.current, {
        opacity: 1,
        duration: 1
      });
      tl.to(expandRef.current.childNodes, {
        opacity: 1,
        duration: 0.3,
        stagger: 0.1
      }).yoyo()
      
    }
  }, [expanded]);

  useEffect(() => {
    setExpanded(expandOnce);
  }, [expandOnce]);

  return (
    <div
      className='cloth-expansion flex w-24 lg:w-full flex-wrap justify-center items-center'>
      <div className='z-10'>
        <button
          onClick={() => setExpanded(!expanded)}
          className='rounded-full w-12 h-12 flex justify-center items-center focus:outline-none' 
          style={{background: '#5C0BD9', zIndex: 4}}
          aria-label='Click on the button for options to swap lower wear of the human illustration.'  
        >
          <LegsBtn />
        </button>
      </div>
      <div
        ref={expandRef}
        className='flex cta-view  bg-white rounded-lg justify-center lg:px-8 items-center pt-8 lg:pt-0'> 
          <button 
            onClick={() => handleChange(1)}
            className='w-24 h-12 interact-icon'
            aria-label="Click to select casual indigo shorts and blue sneakers with white laces."
          >
            <LegsThumb1/>
          </button>  
          <div className='w-full text-center flex justify-center'>
            <button
              onClick={() => handleChange(2)}
              className='w-16 m-3 lg:m-0 h-12 interact-icon' 
              aria-label="Click to select casual indigo pants with burgundy ballerinas."
            >
              <LegsThumb2 />
            </button>
          </div>
          <button
            onClick={() => handleChange(3)}
            className='w-16 m-3 lg:m-0 h-12 interact-icon'
            aria-label="Click to select mini burgundy skirt with burgundy ballerinas."
          >
            <LegsThumb3 />
          </button>
      </div>
    </div>
  )
}